export default "/images/icone-check.svg?33566cb3f346d91ea400d38f69bbe988";